import { createSelector } from 'reselect';
import { getTrolleyTotals } from './get-totals';

export const getAreMinimumOrderValuesLoaded = createSelector(
  [getTrolleyTotals],
  ({ deliveryMinimumOrderValue, collectionMinimumOrderValue }) =>
    !!deliveryMinimumOrderValue?.amount && !!collectionMinimumOrderValue?.amount,
);
